export default "__VITE_ASSET__469f8414__"